(() => {
  if (window.__vqCartQuickActionBound) return;
  window.__vqCartQuickActionBound = true;

  const openAccount = () => {
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;

    if (isDesktop) {
      const accountPopoverButton = document.querySelector('.account-popover .account-button');
      if (accountPopoverButton) {
        accountPopoverButton.click();
        return;
      }
    }

    const accountDrawer = document.querySelector('dialog-component.account-drawer');
    if (accountDrawer && typeof accountDrawer.showDialog === 'function') {
      accountDrawer.showDialog();
      return;
    }

    const accountDrawerButton = document.querySelector('.account-drawer .account-button');
    if (accountDrawerButton) {
      accountDrawerButton.click();
    }
  };

  const openCart = (trigger) => {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
      return;
    }

    const cartTrigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
    if (cartTrigger) {
      cartTrigger.click();
      return;
    }

    const cartUrl = trigger?.getAttribute('data-cart-url');
    if (cartUrl) window.location.href = cartUrl;
  };

  document.addEventListener('click', (event) => {
    const scrollTopTrigger = event.target.closest('[data-vq-scroll-top]');
    if (scrollTopTrigger) {
      event.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const accountTrigger = event.target.closest('[data-vq-open-account]');
    if (accountTrigger) {
      event.preventDefault();

      const menuDetails = document.querySelector('#Details-menu-drawer-container.menu-open, #Details-menu-drawer-container[open]');
      if (menuDetails) {
        const headerDrawer = menuDetails.closest('header-drawer');
        if (headerDrawer && typeof headerDrawer.close === 'function') {
          headerDrawer.close();
        } else {
          menuDetails.classList.remove('menu-open');
          menuDetails.removeAttribute('open');
        }

        window.setTimeout(() => openAccount(), 260);
        return;
      }

      openAccount();
      return;
    }

    const trigger = event.target.closest('[data-vq-open-cart]');
    if (!trigger) return;

    event.preventDefault();

    const menuDetails = document.querySelector('#Details-menu-drawer-container.menu-open, #Details-menu-drawer-container[open]');
    if (menuDetails) {
      const headerDrawer = menuDetails.closest('header-drawer');
      if (headerDrawer && typeof headerDrawer.close === 'function') {
        headerDrawer.close();
      } else {
        menuDetails.classList.remove('menu-open');
        menuDetails.removeAttribute('open');
      }

      window.setTimeout(() => openCart(trigger), 260);
      return;
    }

    openCart(trigger);
  });
})();
